import { render, staticRenderFns } from "./RowPaymentHistory.vue?vue&type=template&id=54ab3d9e&scoped=true"
import script from "./RowPaymentHistory.vue?vue&type=script&lang=ts"
export * from "./RowPaymentHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab3d9e",
  null
  
)

export default component.exports